import React, { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import { useWeb3React } from '@web3-react/core';

import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

import { useAppDispatch, useAuth } from 'hooks';

import { walletModalActions } from 'store/wallet-modal';

const MainButton = styled(Button)`
	${css`
		background-color: transparent;
		color: white;
		border: 2px solid #b8cdf5;
		padding: 6px 16px;
		border-radius: 4px;
		margin-right: 10px;
	`}
`;

const DisconnectedView: React.ComponentType = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<img src="/icons/wallet.png" height={20} />
			<Box sx={{ width: 8 }} />
			<Typography
				sx={{
					fontWeight: 'bold',
				}}
			>
				Connect
			</Typography>
		</Box>
	);
};

const ConnectedView: React.ComponentType = () => {
	const { account } = useWeb3React();

	let activeAccount = account || '';
	activeAccount = activeAccount.slice(0, 6) + '...' + activeAccount.slice(-4);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
			}}
		>
			<img src="/icons/wallet.png" height={20} />
			<Box sx={{ width: 8 }} />
			<Typography
				sx={{
					fontWeight: 'bold',
				}}
			>
				{activeAccount}
			</Typography>
		</Box>
	);
};

const ConnectionButton: React.ComponentType = () => {
	const { logout } = useAuth();
	const { account } = useWeb3React();
	const dispatch = useAppDispatch();

	const onConnectionButtonClick = useCallback(() => {
		if (!account) dispatch(walletModalActions.openWalletModal());
	}, [account, dispatch]);

	return (
		<div>
			<MainButton onClick={onConnectionButtonClick}>
				{account ? <ConnectedView /> : <DisconnectedView />}
			</MainButton>
			{account && (
				<MainButton onClick={logout}>
					<Typography
						sx={{
							fontWeight: 'bold',
						}}
					>
						{'Disconnect'}
					</Typography>
				</MainButton>
			)}
		</div>
	);
};

export { ConnectionButton };
